const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the mention text box component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users injected to gain access to the Users resource
 */
app
.directive('mentionTextBox', ['Users', '$q', '$sce', function (Users, $q, $sce) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      message: '=',
      mentions: '=',
      placeholder: '@',
      submit: '=',
      allowSubmit: '=',
      cancel: '=',
      focus: '='
    },
    template: require('../../templates/directives/mention-text-box.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var characters = 'abcdefghijklmnopqrstuvwxyz123456789';
      self.comment = '';
      self.textId = 'edit-';

      self.submit = function() {
        var parent = document.getElementById(self.textId);
        var children = parent.childNodes;
        $scope.mentions = [];
        for (var i = 0; i < children.length; i++) {
          if (children[i] && children[i].id) {
            $scope.mentions.push(children[i].id);
          }
        }
        for (var j = 0; j < $scope.mentions.length; j++) {
          var toReplace = document.getElementById($scope.mentions[j]);
          if (!toReplace) {
            return;
          }
          var user = self.users.selected[$scope.mentions[j]] || self.edit.users[$scope.mentions[j]];
          var text = '';
          if (user) {
            text = '<:' + user.first_name + '.' + user.last_name + ':' + user._id + '>'
          }
          var textNode = document.createTextNode(text);
          parent.replaceChild(textNode, toReplace);
        }
        var txt = document.createElement("textarea");
        txt.innerHTML = parent.innerHTML;
        $scope.message = txt.value;
      };

      self.clear = function() {
        self.comment = '';
        self.mentions = [];
        $scope.allowSubmit = false;
      };

      self.users = {
        loading: false,
        list: [],
        searchActive: false,
        menuId: 'list-',
        selected: {},
        search: function(text) {
          // remove @ from string
          text = text.slice(1);

          // search on second character
          if (text.length < 2) {
            return;
          }

          this.loading = true;
          Users.find({subresource: '', page: 1, per_page: 8, fields: 'first_name,last_name,email,full_name,role,image,office_location,last_login', role: '$ne,external', full_name: '$regex,2,' + text + ',i'}, function (users) {
            self.users.list = users;
            self.users.loading = false;
            self.users.searchActive = true;
          }, function (error) {
            console.log('Error getting users.');
            self.users.loading = false;
          });
        },
        stopSearch: function() {
          self.users.searchActive = false;
        },
        makeTag: function(user) {
          var htmlUserTag = '\xA0<div id="' + user._id + '" onclick="this.parentNode.removeChild(this);" contenteditable="false" class="ui image label">';
          if (user.image) {
            htmlUserTag += '<img src="' + user.image.replace('http:', 'https:').replace('http%', 'https%') + '">';
          }
          htmlUserTag += user.full_name + '</div>\xA0';
          return htmlUserTag;
        },
        select: function(user) {
          this.selected[user._id] = user;
          if(self.searchTest.range.startContainer.parentNode.id === self.textId) {
            var children = document.getElementById(self.textId).childNodes;
            for (var i = 0; i < children.length; i++) {
              if (children[i] && children[i].id && children[i].id.toString() === user._id.toString()) {
                return;
              }
            }

            var htmlUserTag = this.makeTag(user);

            selectElement(self.searchTest.info.mentionSelectedElement, self.searchTest.info.mentionSelectedPath, self.searchTest.info.mentionSelectedOffset);
            var newInfoItems = getTriggerInfo(['@'], true, true);
            var range;
            var sel;
            var startPos = newInfoItems.mentionPosition;
            var endPos = newInfoItems.mentionPosition + newInfoItems.mentionText.length + 1;
            sel = window.getSelection();
            range = document.createRange();
            range.setStart(sel.anchorNode, startPos);
            range.setEnd(sel.anchorNode, endPos);
            range.deleteContents();

            var el = document.createElement('div');
            el.innerHTML = htmlUserTag;
            var frag = document.createDocumentFragment();
            var node;
            var lastNode;

            while ((node = el.firstChild)) {
              lastNode = frag.appendChild(node);
            }

            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
              range = range.cloneRange();
              range.setStartAfter(lastNode);
              range.collapse(true);
              sel.removeAllRanges();
              sel.addRange(range);
            }
          }

          this.stopSearch();
        },
        remove: function(id) {
          var elem = document.getElementById(id + '');
          elem.parentNode.removeChild(elem);
        }
      };

      for (var i = 0; i < 9; i++) {
        self.users.menuId += characters[Math.floor(Math.random() * characters.length)];
      }
      for (var i = 0; i < 9; i++) {
        self.textId += characters[Math.floor(Math.random() * characters.length)];
      }

      self.searchTest = {
        eligible: false,
        rollingString: '',
        range: null,
        info: null
      };

      self.edit = {
        pauseMessage: false,
        users: {},
        replace: function(input) {
          if (!input || typeof input !== 'string') {
            return input;
          }
          var modified = input.slice(0);
          var items = [];
          var pair = [];
          for (var i = 0; i < modified.length; i++) {
            if (!pair.length) {
              if (modified[i] && modified[i] === '<' && modified[i + 1] && modified[i + 1] === ':') {
                pair.push(i);
                continue;
              }
            }
            if (pair.length) {
              if (modified[i] === '>') {
                pair.push(i + 1);
                items.push(pair);
                pair = [];
              }
            }
          }
          if (items.length) {
            for (var j = items.length - 1; j >= 0; j--) {
              var user = modified.substring(items[j][0], items[j][1]);
              if (user && typeof user === 'string') {
                var splitUser = user.split(':');
                var username = splitUser[1];
                var id = splitUser && splitUser.length ? splitUser[2] : null;
                id = id && typeof id === 'string' ? id.slice(0, -1) : '';
                if (id && self.edit.users[id]) {
                  var newItem = self.users.makeTag(self.edit.users[id]);
                  modified = modified.replace(user, newItem);
                } else if (username) {
                  modified = modified.replace(user, '@' + username);
                } else {
                  modified = modified.replace(user, '');
                }
              }
            }
          }
          return modified;
        },
        findMentions: function(mentions) {
          var deferred = $q.defer();
          if (!mentions || !mentions.length) {
            deferred.resolve([]);
          }

          Users.find({
            subresource: '',
            fields: 'first_name,last_name,email,full_name,role,image,office_location,last_login',
            _id: '$in,' + mentions.length + ',' + mentions.join(',')
          }).$promise
          .then(function (users) {
            deferred.resolve(users);
          }).catch(function (error) {
            deffered.reject()
            console.log('Error getting mentioned users.');
          });

          return deferred.promise;
        }
      };

      if ($scope.cancel === false) {
        $scope.$watch('cancel', function(newVal, oldVal) {
          if (newVal && !oldVal) {
            $scope.cancel = true;
            self.clear();
          }
        });
      }

      $scope.$watch('message', function(newVal, oldVal) {
        if (self.edit.pauseMessage || newVal === oldVal) {
          return;
        }
        self.edit.pauseMessage = true;
        // Parse tags into comment
        self.edit.findMentions($scope.mentions)
        .then(function(users) {
          for (var i = 0; i < users.length; i++) {
            self.edit.users[users[i]._id] = users[i];
          }
          var tempComment = self.edit.replace($scope.message);
          self.comment = $sce.trustAsHtml(tempComment);
          self.edit.pauseMessage = false;
        });
      });
      $scope.$watch('atMention.comment', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        self.searchTest.eligible = false;
        self.searchTest.rollingString = '';
        self.searchTest.range = null;
        if (!newVal) {
          self.users.stopSearch();
          $scope.allowSubmit = false;
          return;
        }
        $scope.allowSubmit = true;
        // Check difference from oldVal
        for (var i = 0; i < newVal.length; i++) {
          // rolling eligibility checking

          // check for proper @ state to begin eligibility
          if (newVal[i] === '@' && i === 0 || newVal[i] === '@' && newVal[i - 1] === ' ') {
            self.searchTest.eligible = true;
            self.searchTest.info = getTriggerInfo(['@'], true, true);
          }
          // Check for preceding space code later in the string
          if (newVal[i] === '@' && i > 5 && newVal.substring(i - 6, i) === '&nbsp;') {
            self.searchTest.eligible = true;
            self.searchTest.info = getTriggerInfo(['@'], true, true);
          }
          // If character is a space, rolling test is ineligible
          if (newVal[i] === ' ' || newVal[i] === '&') {
            self.searchTest.eligible = false;
            self.searchTest.rollingString = '';
            self.searchTest.range = null;
          }
          // If eligible - add character to rolling string
          if (self.searchTest.eligible) {
            self.searchTest.rollingString += newVal[i];
          }
          // Keep checking till there is a difference or the end
          if (newVal[i] === oldVal[i] && i < (newVal.length - 1)) {
            continue;
          }
          // Difference detected - if eligible begin search, else stop search
          if (self.searchTest.eligible) {
            // start search with rolling string
            self.users.search(self.searchTest.rollingString);
            self.searchTest.range = window.getSelection().getRangeAt(0);
            return;
          }
          // Stop search
          self.users.stopSearch();
        }
      });

      $scope.$watch('submit', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.edit.pauseMessage = true;
        self.submit();
        $scope.submit = false;
        self.clear();
        // Don't watch message change from within
        setTimeout(function() {
          self.edit.pauseMessage = false;
        }, 200);
      });

      $scope.$watch('focus', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        setTimeout(function() {
          var el = document.getElementById(self.textId).focus();
          $scope.focus = false;
          $scope.$apply();
        }, 0);
      });
      // -------------- Begin items mostly taken from Mentio --------------
      function getTriggerInfo (triggerCharSet, requireLeadingSpace, menuAlreadyActive, hasTrailingSpace) {
        var selected;
        var path;
        var offset;

        var selectionInfo = getContentEditableSelectedPath();
        if (selectionInfo) {
          selected = selectionInfo.selected;
          path = selectionInfo.path;
          offset = selectionInfo.offset;
        }
        var effectiveRange = getTextPrecedingCurrentSelection();

        if (effectiveRange !== undefined && effectiveRange !== null) {
          var mostRecentTriggerCharPos = -1;
          var triggerChar;
          triggerCharSet.forEach(function(c) {
              var idx = effectiveRange.lastIndexOf(c);
              if (idx > mostRecentTriggerCharPos) {
                mostRecentTriggerCharPos = idx;
                triggerChar = c;
              }
          });

          if (mostRecentTriggerCharPos >= 0 &&
            (
              mostRecentTriggerCharPos === 0 ||
              !requireLeadingSpace ||
              /[\xA0\s]/g.test(effectiveRange.substring(mostRecentTriggerCharPos - 1, mostRecentTriggerCharPos))
            )
          ) {
            var currentTriggerSnippet = effectiveRange.substring(mostRecentTriggerCharPos + 1, effectiveRange.length);

            triggerChar = effectiveRange.substring(mostRecentTriggerCharPos, mostRecentTriggerCharPos + 1);
            var firstSnippetChar = currentTriggerSnippet.substring(0,1);
            var leadingSpace = currentTriggerSnippet.length > 0 &&
              (
                firstSnippetChar === ' ' ||
                firstSnippetChar === '\xA0'
              );
            if (hasTrailingSpace) {
                currentTriggerSnippet = currentTriggerSnippet.trim();
            }
            if (!leadingSpace && (menuAlreadyActive || !(/[\xA0\s]/g.test(currentTriggerSnippet)))) {
              return {
                mentionPosition: mostRecentTriggerCharPos,
                mentionText: currentTriggerSnippet,
                mentionSelectedElement: selected,
                mentionSelectedPath: path,
                mentionSelectedOffset: offset,
                mentionTriggerChar: triggerChar
              };
            }
          }
        }
      };
      function selectElement (targetElement, path, offset) {
        var range;
        var elem = targetElement;
        if (path) {
          for (var i = 0; i < path.length; i++) {
            elem = elem.childNodes[path[i]];
            if (elem === undefined) {
              return;
            }
            while (elem.length < offset) {
              offset -= elem.length;
              elem = elem.nextSibling;
            }
            if (elem.childNodes.length === 0 && !elem.length) {
              elem = elem.previousSibling;
            }
          }
        }
        var sel = window.getSelection();
        range = document.createRange();
        range.setStart(elem, offset);
        range.setEnd(elem, offset);
        range.collapse(true);
        try{sel.removeAllRanges();}catch(error){}
        sel.addRange(range);
        targetElement.focus();
      };
      function getContentEditableSelectedPath() {
        // content editable
        var sel = window.getSelection();
        var selected = sel.anchorNode;
        var path = [];
        var offset;
        if (selected != null) {
          var i;
          var ce = selected.contentEditable;
          while (selected !== null && ce !== 'true') {
            i = getNodePositionInParent(selected);
            path.push(i);
            selected = selected.parentNode;
            if (selected !== null) {
              ce = selected.contentEditable;
            }
          }
          path.reverse();
          // getRangeAt may not exist, need alternative
          offset = sel.getRangeAt(0).startOffset;
          return {
            selected: selected,
            path: path,
            offset: offset
          };
        }
      };
      function getNodePositionInParent (elem) {
        if (elem.parentNode === null) {
          return 0;
        }
        for (var i = 0; i < elem.parentNode.childNodes.length; i++) {
          var node = elem.parentNode.childNodes[i];
          if (node === elem) {
            return i;
          }
        }
      };
      function getTextPrecedingCurrentSelection () {
        var text;
        var selectedElem = window.getSelection().anchorNode;
        if (selectedElem != null) {
          var workingNodeContent = selectedElem.textContent;
          var selectStartOffset = window.getSelection().getRangeAt(0).startOffset;
          if (selectStartOffset >= 0) {
            text = workingNodeContent.substring(0, selectStartOffset);
          }
        }
        return text;
      };
      // -------------- End items mostly taken from Mentio --------------
    }],
    controllerAs: 'atMention'
  };
}]);
